// extracted by css-extract-rspack-plugin
export default {"tooltip":"src-wab-client-plasmic-plasmic_kit_pricing-PlasmicHoverableText-module__tooltip-vCRhfX","dottedUnderlineBorder":"src-wab-client-plasmic-plasmic_kit_pricing-PlasmicHoverableText-module__dottedUnderlineBorder-j8B6GG","slotTargetChildren":"src-wab-client-plasmic-plasmic_kit_pricing-PlasmicHoverableText-module__slotTargetChildren-x49f7t","text___26Bq":"src-wab-client-plasmic-plasmic_kit_pricing-PlasmicHoverableText-module__text___26Bq-FaeuyD","text26Bq":"src-wab-client-plasmic-plasmic_kit_pricing-PlasmicHoverableText-module__text___26Bq-FaeuyD"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"tooltip\":\"src-wab-client-plasmic-plasmic_kit_pricing-PlasmicHoverableText-module__tooltip-vCRhfX\",\"dottedUnderlineBorder\":\"src-wab-client-plasmic-plasmic_kit_pricing-PlasmicHoverableText-module__dottedUnderlineBorder-j8B6GG\",\"slotTargetChildren\":\"src-wab-client-plasmic-plasmic_kit_pricing-PlasmicHoverableText-module__slotTargetChildren-x49f7t\",\"text___26Bq\":\"src-wab-client-plasmic-plasmic_kit_pricing-PlasmicHoverableText-module__text___26Bq-FaeuyD\",\"text26Bq\":\"src-wab-client-plasmic-plasmic_kit_pricing-PlasmicHoverableText-module__text___26Bq-FaeuyD\"}";
        // 1791313080798
        var cssReload = require("../../../../../../node_modules/.pnpm/@rspack+core@1.7.12_@swc+helpers@0.5.23/node_modules/@rspack/core/dist/cssExtractHmr.js").cssReload(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  